import { useQuery } from '@tanstack/react-query';

import { fetchUnreadCount } from '../services';

export function useUnreadCount() {
  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: async () => {
      const data = await fetchUnreadCount();
      return data.count;
    },
    refetchInterval: 60_000,
  });
}
